/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".white-space-wrap[_ngcontent-%COMP%]{white-space:normal;font-family:Opensans-Regular}.msg-body[_ngcontent-%COMP%]{font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:16px;font-weight:400}.msg-title[_ngcontent-%COMP%]{font-family:Pru-Modern SemiCond,Arial,Helvetica Neue,Helvetica,sans-serif;font-size:30px;font-weight:600;color:#000}"];
export { styles as styles };
